import { ExternalIcon } from "@icons/ExternalIcon";
import { MapControl } from "./MapControl";
import { useCallback } from "react";
import { useMap } from "@vis.gl/react-google-maps";

const ZoomControl = () => {
  const map = useMap();

  const handleZoom = useCallback(
    (direction: number) => () => {
      const currentZoom = map?.getZoom();
      if (currentZoom && map) {
        map.setZoom(currentZoom + direction);
      }
    },
    [map],
  );

  return (
    <MapControl
      items={[
        {
          icon: <ExternalIcon svgName="plus" />,
          onPress: handleZoom(1),
          key: "zoom-in",
        },
        {
          icon: <ExternalIcon svgName="minus" />,
          onPress: handleZoom(-1),
          key: "zoom-out",
        },
      ]}
    />
  );
};
export { ZoomControl };
